module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('full-calendar', {
    staticClass: "full-calendar",
    attrs: {
      "options": _vm.calendarOptions
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c503dbee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WorkingCalendar.vue
// module id = 773
// module chunks = 1